import Ticket from 'modules/Tickets/Ticket/Ticket'
import Sagas from 'modules/Tickets/Ticket/saga'
import Reducer from 'modules/Tickets/Ticket/reducer'

export default Ticket

export { Sagas, Reducer }
